import React, { useState } from "react";
import styles from "./Header.module.css";
import { AuthContext } from "../../Constants/AuthProvider.js";
import irluxepic from "./../../images/irluxe-black.png";
import { Link } from "react-router-dom";
const Header = () => {
  const [name, setName] = useState(localStorage.getItem("name"));
  const { onLogout } = React.useContext(AuthContext);
  return (
    <>
      <div className={styles.topIrluxe}>
        <img src={irluxepic} />
        <Link to="/learning-center">
          <div className={styles.guider}>
            <i class="fa-regular fa-book-open"></i>
            راهنما
          </div>
        </Link>
      </div>
      <div className={styles.headnav}>
        <div className={styles.rightBox}>
          <div className={styles.rightUsername}>
            <i className="fa-regular fa-user-circle"></i>
            {name}
          </div>
          <div className={styles.stars}>
            <i class="fa-solid fa-star"></i>
            <i class="fa-solid fa-star"></i>
            <i class="fa-solid fa-star"></i>
            <i class="fa-thin fa-star"></i>
            <i class="fa-thin fa-star "></i>
          </div>
        </div>

        <div className={styles.leftBox}>
          {/* <div className={styles.leftItemBox}>
            <div className={styles.newNoticaition}></div>
            <i class="far fa-bell"></i>
            <div className={styles.itemsText}></div>
          </div> */}
          <div className={styles.leftItemBox} onClick={onLogout}>
            <i class="fa-solid fa-right-from-bracket"></i>
            <div className={styles.itemsText}></div>
          </div>
        </div>
      </div>

      {/* <Link to="/learning-center">
          <div className={styles.leftItemBox}>
            <i class="fa-regular fa-chalkboard-user"></i>
            <div className={styles.itemsText}>آموزش ها</div>
          </div>
        </Link>
     
*/}
    </>
  );
};

export default Header;
